<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-pot-salary-interval" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>
                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" disabled label="Poäng från" v-model="from" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" disabled label="Poäng till" v-model="to" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field :decimal-sv="true" bg-color="white" disabled label="Grundlön" v-model="salary" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field  :decimal-sv="true" bg-color="white" label="Ny lön" v-model="potsalary" variant="outlined"></v-text-field>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>

    import WageService from "../../../Services/WageService";
    import { getCurrentInstance } from 'vue'
    
    export default {
        emits: ['updated'],
        name: 'update-pot-salary-interval',
        props: {

        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                await WageService.updatePotSalaryInterval(this.salaryIntervalId, this.potsalary);
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");
            },
            open(item) {
                this.salaryIntervalId = item.SalaryIntervalId;
                this.from = item.From;
                this.to = item.To;
                this.salary = item.Salary;
                this.potsalary = item.PotSalary;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create() {
                this.reset();
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            reset() {
                this.from = null;
                this.to = null
                this.salary = null
                this.salaryIntervalId = null;
                this.potsalary = null;
            },
        },
        data() {
            return {
                from: null,
                to: null,
                salary: null,
                salaryIntervalId: null,
                potsalary:null,
                dialogueVisible: false,
                thisModal: {},
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
